import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import TransporteurSelect from 'components/Shared/TransporteurSelect';
import DropZone from 'components/Shared/DropZone';
import { ReclamationActionDetailCodes } from 'constants.js';

import { getTransporteurEmail } from 'utils/transporteursHelper';

const styles = theme => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    input: {
        marginTop: 10
    }
});

/* Liste des réponses possibles */
const reponses = [
    'Demande de destruction',
    'Demande de retour (marchandise chez le transporteur)',
    'Demande de retour (marchandise chez le client)',
    'Le client garde le colis'
];

const placeholders = [
    '',
    'Pour le ou les colis perdus du(des) récépissé(s) ci-dessous, nous vous facturons le remplacement.\nMerci de nous retourner le colis non livré et de ne surtout pas le livrer au client.\nUn avoir vous sera fait à réception de la marchandise.\n',
    'Pour le récépissé ci-dessous, un colis étiqueté au nom de [Raison Sociale] a été livré chez ----- .\n\nMerci de procéder à la reprise à votre charge et nous faire le suivi.\n',
    ''
];

class RenvoiAvecFacturationDialogContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            transporteurId: props.transporteurId,
            resultat: null,
            ticketChronopost: '',
            destinataires: getTransporteurEmail(props.transporteurId, props.transporteurs, props.depotDepart),
            memo: '',
            fichiersIds: []
        };
    }

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action, transporteurs } = this.props;

        if (newState.transporteurId === -1) {
            return null;
        }
        if (newState.resultat === null) {
            return null;
        }


        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Transporteur,
                type: ReclamationActionDetailType.TransporteurId,
                libelle: 'Transporteur',
                position: 0,
                valeurInteger: newState.transporteurId
            }, {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Demande : ',
                position: 1,
                valeurString: reponses[Number(newState.resultat)],
                valeurInteger: Number(newState.resultat)
            }]
        };

        const isChronopost = transporteurs.find(x => x.id === newState.transporteurId) && transporteurs.find(x => x.id === newState.transporteurId).nom.startsWith('Chronopost');

        if (isChronopost) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.TicketChronopost,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de ticket chronopost',
                position: 3,
                valeurString: newState.ticketChronopost
            });
        }
        else {


            if (newState.destinataires === undefined || newState.destinataires === null || newState.destinataires === '') {
                return null;
            }


            actionData.details.push({
                code: ReclamationActionDetailCodes.Email,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Email(s) destinataire(s)',
                position: 3,
                valeurString: newState.destinataires
            });

            actionData.details.push({
                code: ReclamationActionDetailCodes.Memo,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Mémo',
                position: 4,
                valeurString: newState.memo
            });

            if (newState.fichiersIds.length > 0) {
                actionData.fichiersIds = newState.fichiersIds;
            }
        }

        return actionData;
    }

    handleChange = (event) => {

        const { colis, transporteurs, depotDepart } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        if (event.target.name === 'transporteurId') {
            newState.destinataires = getTransporteurEmail(newState.transporteurId, transporteurs, depotDepart);
        }

        if (newState.resultat !== null && (newState.resultat !== this.state.resultat)) {
            newState.memo = placeholders[Number(newState.resultat)];

            if (newState.memo !== '') {

                colis.forEach(function (coli, index) {

                    newState.memo += `Colis ${index + 1} : ${coli.numeroTracking} / ${coli.numeroSSCC} / ${coli.numeroSupport}` + (coli.recepisse !== null ? ' / ' + coli.recepisse : '') + '\n';

                });
            }
        }


        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes, transporteurs } = this.props;
        const { transporteurId, resultat } = this.state;

        let transporteur = transporteurs.find(x => x.id === transporteurId);

        let transporteurNom = '';

        if (transporteur !== undefined) {
            transporteurNom = transporteur.nom;
        }

        const isChronopost = transporteurNom.startsWith('Chronopost');

        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                {!isChronopost && <Typography variant="body2" gutterBottom className={classes.detailValue}>Envoyer un mail au transporteur ({transporteurNom})</Typography>}

                { !resultat && (
                    <Typography variant="body2" gutterBottom className={classes.detailValue}>Eventuellement, générer un dossier après-vente lié pour le service retour</Typography>
                )}

                {(resultat === "1" || resultat === "2") && (
                    <Typography variant="body2" gutterBottom className={classes.detailValue}>Générer un dossier après-vente lié pour le service retour</Typography>
                )}

                {resultat === "2" && <Typography variant="body2" gutterBottom className={classes.detailValue}>{`Envoyer un mail à l'ATCS (si il y a une pièce)`}</Typography>}

                <TransporteurSelect value={transporteurId} onChange={this.handleChange} all={false} isRequired />

                <FormControl component="fieldset" className={classes.input} required>
                    <FormLabel component="legend">Demande : </FormLabel>
                    <RadioGroup                        
                        aria-label="controle"
                        name="resultat"
                        className={classes.group}
                        value={resultat}
                        onChange={this.handleChange}
                    >
                        {reponses.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}

                    </RadioGroup>
                </FormControl>

                {isChronopost && <TextField className={classes.input} id="ticketChronopost" name="ticketChronopost" label="Numéro de ticket Chronopost" value={this.state.ticketChronopost} onChange={this.handleChange} type="text" fullWidth />}

                {!isChronopost && (
                    <React.Fragment>
                        <TextField className={classes.input} id="destinataires" name="destinataires" label='Destinataires du mail (séparé par un ";")' type="text" value={this.state.destinataires} onChange={this.handleChange} fullWidth required/>

                        <TextField className={classes.input} id="memo" name="memo" label="Mémo" type="text" value={this.state.memo} onChange={this.handleChange} fullWidth multiline />

                        <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                    </React.Fragment>
                )}
            </DialogContent>
        );
    }
}

RenvoiAvecFacturationDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    transporteurId: PropTypes.number.isRequired,
    transporteurs: PropTypes.array.isRequired
};

export default withStyles(styles)(RenvoiAvecFacturationDialogContent);